import {AppState} from '../store';

export const getFees = (state: AppState) => state.fees;

export const getFeesIsWithdrawingToke = (state: AppState) =>
  state.fees.isWithdrawingToken;

export const getFeesIsWithdrawingEther = (state: AppState) =>
  state.fees.isWithdrawingEther;
